import React, { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import ProfileDataV2 from "./ProfileDataV2";
import Flexbox from "flexbox-react";
import classNames from "classnames";
import { Popover, Menu, MenuDivider, MenuItem, Button, PopoverInteractionKind, Classes, NonIdealState } from "@blueprintjs/core";
const UserProfileTemplateV2 = ({ userId }) => {
  const [templateList, setTemplateList] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) return;
    fetchProfileTemplateList();
  }, [userId]);

  const fetchProfileTemplateList = async () => {
    try {
      const response = await axios.get(`${Cookies.get("apiEnv")}/fetch_profile_data/profile_template_list?user_id=${userId}`);
      const templates = response.data.profile_template || [];

      // find default only once
      const defaultTemplate = templates.find(t => t.default);

      setTemplateList(templates);
      setSelectedTemplate(defaultTemplate || templates[0] || null); // fallback: pick first
      setLoading(false);
    } catch (err) {
      setTemplateList([]);
      setSelectedTemplate(null);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = e => {
    const templateId = parseInt(e.target.value, 10); // convert string to number
    const template = templateList.find(t => t.id === templateId);
    setSelectedTemplate(template || null);
  };

  if (loading) {
    return (
      <Flexbox flexGrow={1} flexDirection="column">
        <Flexbox className="bp3-card" flexGrow={1} marginTop="20px">
          <NonIdealState
            title={I18n.t("js.nothing_to_show")}
            description={I18n.t("js.there_is_no_profile_template_to_show")}
            icon="id-number"
            className="bp3-text-muted"
          />
        </Flexbox>
      </Flexbox>
    );
  }

  return (
    <>
      <Flexbox flexGrow={1} flexDirection="column" className="fixed-width-container">
        <Flexbox flexDirection="row" flexGrow={1}>
          <Flexbox flexGrow={1} paddingTop="5px">
            <h3 className={Classes.HEADING}>{selectedTemplate?.name}</h3>
          </Flexbox>
          <Flexbox flexGrow={0}>
            <Popover
              portalContainer={document.body}
              content={
                <Menu>
                  {templateList.map(template => (
                    <MenuItem key={template.id} text={template.name} onClick={() => setSelectedTemplate(template)} />
                  ))}
                </Menu>
              }
              position="bottom"
              interactionKind={PopoverInteractionKind.CLICK}
              inline={true}
              autoFocus={false}
            >
              <Button
                rightIcon="caret-down"
                // loading={this.isLoading}
              >
                <span>{selectedTemplate.name}</span>
              </Button>
            </Popover>
          </Flexbox>
        </Flexbox>
        <Flexbox>
          <Flexbox marginTop="3px" className="bp3-running-text">
            {selectedTemplate?.description}
          </Flexbox>
        </Flexbox>
      </Flexbox>

      <Flexbox
        flexGrow={1}
        width="100hw"
        alignContent="stretch"
        flexDirection="column"
        // flexDirection={this.props.isDisplayDrawer ? 'row' : 'column'}
        paddingBottom="0px"
         
      >
        <Flexbox flexDirection="column" flexGrow={1} className="fixed-width-container">
          {selectedTemplate && <ProfileDataV2 userId={userId} profileTemplateId={selectedTemplate.id} />}
        </Flexbox>
      </Flexbox>
    </>
  );
};

export default UserProfileTemplateV2;
